import { Slots, DateSlot, TimeSlot } from "types";
import { formatDate } from "helpers";

interface DoctorData {
  slots: {
    entry: {
      resource: {
        start: string;
        end: string;
      };
    }[];
  };
}

const splitIntoDateAndTime = (date: Date) => {
  const dateAndTime = formatDate(date, {
    dateStyle: "short",
    timeStyle: "short",
  });

  return dateAndTime.split(", ");
};

const splitIntoAmOrPM = (time: string) => {
  return time.split(" ")[1].toLowerCase() as "am" | "pm";
};

const transformSlots = (doctor: DoctorData): Slots => {
  const today = new Date();
  const slots = doctor.slots.entry;

  return slots.reduce<Slots>((previous, { resource: { start, end } }) => {
    const startDate = new Date(start);
    const [date, time] = splitIntoDateAndTime(startDate);
    const amOrPm = splitIntoAmOrPM(time);

    const previousSlot: DateSlot = {
      ...previous[date],
      am: (previous[date] || { am: [] }).am,
      pm: (previous[date] || { pm: [] }).pm,
    };

    const currentTimes: TimeSlot[] = [
      ...previousSlot[amOrPm],
      { startAt: start, endAt: end, date, time },
    ];

    const currentSlot: DateSlot = {
      ...previousSlot,
      date,
      [amOrPm]: currentTimes,
    };

    if (startDate > today) {
      return { ...previous, [date]: currentSlot };
    } else {
      return previous;
    }
  }, {});
};

export default transformSlots;
